<template>
  <div class="dropdown">

    <!-- Dropdown header -->
    <div class="dropdown-header">
      <h3 class="dropdown-header-title"> {{ listNaming }} </h3>

      <!-- Horizontal scrollbar -->
      <div class="dropdown-header-scrollbar">
        <div class="dropdown-header-scrollbar-thumb"
             :style="{ width: scrollbarPosition }"
        ></div>
      </div>
      <!---->

    </div>
    <!---->

    <div class="dropdown-inner">

      <!-- Dropdown list -->
      <div class="dropdown-list"
           ref="list"
           @scroll="handlerScroll"
           v-if="list.length"
      >

        <!-- Menu link -->
        <dropdown-link v-for="item in list"
                       :item="item"
                       :key="item.entity_id"
        />
        <!---->

        <!-- List shadows -->
        <div class="dropdown-list-hidden top"
             :class="{'is-hidden': scrollbarPosition === '0%'}"
             v-if="listHeight > 573"
        ></div>
        <!---->

        <!-- Scroll to bottom -->
        <div class="dropdown-list-arrow"
             v-if="scrollbarPosition < '100%' && listHeight > 573"
             @click="scrollToBottom"
        ></div>
        <!---->

      </div>
      <div v-else>
        <bounce-loader />
      </div>
      <!---->

    </div>
  </div>
</template>

<script>
import BounceLoader from 'theme/components/theme/blocks/Home/Preloaders/BounceLoader'

export default {
  components: {
    DropdownLink: () => import('theme/components/core/blocks/Shop/Navigation/Dropdown/DropdownLink'),
    BounceLoader
  },
  props: {
    list: {
      type: Array
    },
    listNaming: {
      type: String
    }
  },
  data () {
    return {
      scrollbarPosition: '0%',
      listHeight: 0
    }
  },
  mounted () {
    this.listHeight = this.getListHeight
  },
  computed: {
    // Get all scroll height in list
    getScrollHeight () {
      return this.$refs.list.scrollHeight - this.$refs.list.clientHeight // 40px - height of menu link section
    },
    getListHeight () {
      return this.$refs.list.scrollHeight
    }
  },
  methods: {
    handlerScroll () {
      this.scrollbarPosition = `${100 / (this.getScrollHeight / this.$refs.list.scrollTop)}%`
    },
    scrollToBottom () {
      this.$refs.list.scrollTo({ top: this.getListHeight, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown {
  width: 262px;
  height: 630px;
  margin: auto;

  position: absolute;
  top: 0;
  left: 262px;

  background: #f5f5f5;
  border-left: 1px solid #fff;
  border-radius: 5px;
  z-index: 5;

  &-inner {
    padding: 10px 0;
  }

  &-header {
    padding: 10px 20px;

    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    border-bottom: 1px solid #fff;
    z-index: 5;

    &-title {
      margin: 0;
      padding: 0;

      color: #111;
      font-size: 16px;
      font-weight: 600;

      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    &-image {
      width: 20px;
      height: 20px;

      padding-left: 10px;
    }

    &-scrollbar {
      width: 100%;
      height: 1px;
      margin: auto;

      position: absolute;
      right: 0;
      left: 0;
      bottom: 0;

      z-index: 5;
      transition: .2s;

      &-thumb {
        width: 30px;
        height: 1px;
        background: #f5a623;
      }
    }
  }

  &-list {
    height: 573px;

    display: flex;
    flex-direction: column;

    overflow-y: scroll;

    &-hidden {
      width: 100%;
      height: 100px;

      margin: auto;
      position: absolute;

      opacity: 1;
      transition: .2s;

      &.top {
        top: 40px;
        background: linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(245,245,245,1) 100%);
      }

      &.bottom {
        bottom: 0;
        background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(245,245,245,1) 100%);
      }

      &.is-hidden {
        height: 0;
        opacity: 0;
      }
    }

    &-arrow {
      height: 22px;
      width: 22px;
      margin: auto;
      position: absolute;
      right: 0;
      left: 0;
      bottom: 5px;

      background-image: url('../../../../../../assets/shop/arrow.svg');
      background-position: center;
      background-size: 15px;
      background-repeat: no-repeat;

      filter: invert(63%) sepia(94%) saturate(634%) hue-rotate(344deg) brightness(103%) contrast(92%);

      &:hover {
        cursor: pointer;
        bottom: 5px;
        height: 22px;
        width: 22px;
        border-radius: 50%;
        transition: 0.3s;
        box-shadow: 0 0 3px 2px rgba(0, 0, 0, 1);
      }
    }

    &::-webkit-scrollbar {
      width: 0;
    }

    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background: #fff;
    }

    &::-webkit-scrollbar-thumb {
      width: 0;
      border-radius: 10px;
      background: #f5a623;
    }
  }
}
</style>
